<input #hiddenInput
       class="hidden-input"
       (click)="onClick($event)"
       (input)="onInput($event)"
       (keydown)="onKeyDown($event)"
       tabindex="-1"
       type="text">
